import { z } from "zod";

export const chatChannelSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "channelForm.name.error.required")
    .max(64, "channelForm.name.error.maxLength")
    .regex(/^[A-Za-z0-9_-]+$/, "channelForm.name.error.invalid"),
  display_name: z
    .string()
    .trim()
    .min(1, "channelForm.displayName.error.required")
    .max(128, "channelForm.displayName.error.maxLength"),
  member_user_ids: z.array(z.number()),
});

export type ChatChannelFormValues = z.infer<typeof chatChannelSchema>;
